import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import { useState } from "react";
import styled from "styled-components";
import { EyeIcon } from "../../assets/icons/Icons";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

const StyledLabel = styled.label`
  font-weight: 700;
  color: var(--header-text);
`;

export const InputPassword = ({ label, type, register, errorMessage, ...otherProps }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Container {...otherProps}>
      <StyledLabel>{label}</StyledLabel>
      <FormControl>
        <OutlinedInput
          {...register}
          type={showPassword ? "text" : "password"}
          size="small"
          sx={{ borderRadius: "8px"}}
          placeholder="Contraseña"
          error={errorMessage ? true : false}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <EyeIcon show /> : <EyeIcon />}
              </IconButton>
            </InputAdornment>
          }
        />
        <FormHelperText error>{errorMessage && "*" + errorMessage}</FormHelperText>
      </FormControl>
    </Container>
  );
};
